import * as types from './mutations-types'
// 简历系列
const editorCv = {
  CV_THEME(state, data) {
    state.cv.base.theme_color = data;
  },
  CV_FONT_SIZE(state, data) {
    state.cv.base.font_size = data;
  },
  CV_LINE_HEIGHT(state, data) {
    state.cv.base.line_spacing = data;
  },
  CV_FONT(state, data) {
    state.cv.base.font = data;
  },
  CV_PADDING(state, data) {
    state.cv.base.page_margin = data;
  },
  CV_HEAD_FORMAT(state, data) {
    state.cv.base.head_format = data;
  },
  SHOW_ATTR_NAME(state, data) {
    state.cv.base.show_attr_name = data;
  },
  // SHOW_ATTR_NAME(state, data) {
  //   state.cv.profile.format_pref_show_attr_name = data;
  // },
  TIME_FORMAT(state, data) {
    state.cv.base.time_format = data;
  },
  FORMAT_PRIORITY(state, data) {
    state.cv.base.format_priority = data;
  },
  BODY_FORMAT(state, data) {
    state.cv.base.body_format = data;
  },
  PUNCTUATION_FORMAT(state, data) {
    state.cv.base.punctuation_format = data;
  },
  EDITOR_CV_TOKEN(state, data) {
    state.editorCvToken = data;
  },
  PAGE_SIZE(state, data) {
    state.cv.base.page_size = data;
  },
  SET_OLD_LINE_HEIGHT(state, data) {
    state.oldLineHeight = data;
  },


  /**
   * 设置用户信息，没有actions
   * @param {vuex} state
   * @param {Object} data
   * @param {string} data.key
   * @param {string} data.value
   */
  SET_CV_PROFILE_KEY_VALUE(state, data) {
    state.cv.profile[data.key] = data.value;
  },
  /**
   *
   * @param {vuex} state
   * @param {Object} data
   */
  SET_CV_EDU_KEY_VALUE(state, edus) {
    state.cv.edus = edus;
  },
  SET_CV_WORK_KEY_VALUE(state, data) {
    let works = JSON.parse(JSON.stringify(state.cv.works));
    if (!works[data.num]) {
      works[data.num] = {};
    }
    works[data.num][data.key] = data.value;
    state.cv.works = works;
  },
  SET_CV_ORG_KEY_VALUE(state, data) {
    let orgs = JSON.parse(JSON.stringify(state.cv.orgs));
    if (!orgs[data.num]) {
      orgs[data.num] = {};
    }
    orgs[data.num][data.key] = data.value;
    state.cv.orgs = orgs;
  },
  SET_CV_CUSTOM_KEY_VALUE(state, data) {
    let custom = JSON.parse(JSON.stringify(state.cv.custom_sections));
    let num = 0;
    let title = '';
    let custom_section = {};
    let custom_section_infos = {};
    // if (data.new) {
    //   custom.push({
    //     custom_section: {
    //       category: data.category
    //     },
    //     custom_section_infos: {}
    //   });
    // }
    // console.log(custom, data);
    console.log(data);
    for (let i = 0; i < custom.length; i++) {
      if (custom[i]['custom_section'].category === data.category) {
        num = i;
        title = custom[i].title;
        custom_section = custom[i]['custom_section'];
        custom_section_infos = custom[i]['custom_section_infos'];
        break;
      }
    }
    if (!custom_section_infos[data.num]) {
      custom_section_infos[data.num] = {};
    }
    custom_section_infos[data.num][data.key] = data.value;
    custom[num] = {
      title,
      custom_section,
      custom_section_infos
    };
    state.cv['custom_sections'] = custom;
  },
  SET_CV_OTHER_KEY_VALUE(state, data) {
    let other = JSON.parse(JSON.stringify(state.cv[data.key])) || {};
    let text = {
      other: '活动名称',
      language: '语言名称',
      interest: '兴趣名称',
      skill: '技能名称',
      certificate: '证书名称'
    };
    other.description = data.value;
    state.cv[data.key] = other;
  },


  // 设置模块顺序
  SET_POSITION(state, data) {
    state.cv.base.sections_position = data
  }
}

const info = {
  /**
   * 优化建议所有数据
   * @param {*} state
   * @param {*} data
   */
  SET_CHECK(state, data) {
    state.check = data;
  },
  /**
   * 优化建议检查跳转数据设置
   * @param {*} state
   * @param {*} data
   */
  EDIT_CHECK_DATA(state, data) {
    state.editCheckData = data;
  },
  HIGHLIGHT_SHOW(state, data) {
    state.highlightShow = data;
  }
}

const mutations = {
  ...editorCv,
  ...info,
  [types.GET_CVS] (state, cvs) {
    state.cvs = cvs;
  },
  [types.GET_CV] (state, cv) {
    state.cv = cv;
  },
  [types.GET_SORT_ARY] (state, sortAry) {
    state.sortAry = sortAry;
  },
  [types.CHANGE_PAGE_INDEX] (state, pageIndex) {
    state.pageIndex = pageIndex;
  },
  [types.GET_RATE] (state, rate) {
    state.rate = rate;
  },
  [types.GET_PROFILES] (state, profiles) {
    state.profiles = profiles;
  },
  [types.SET_CV_PAGES] (state, others) {
    state.cvPages = others;
  },
  [types.SET_CV_HEIGHT](state, others) {
    state.cvHeight = others;
  },
  [types.SET_PAGE_HEIGHT](state, others) {
    state.pageHeight = others;
  },
  SET_TEMPLATES(state, data) {
    state.templates = data;
  },
  SET_TEMPS(state, data) {
    state.temps = data;
  },
  SET_DOWNLOAD_CV(state, cb) {
    state.downloadCv = cb;
  },
  SET_IS_AUTO_ONE_PAGE(state, data) {
    state.isAutoOnePage = data;
  },
  SET_AUTO_ONE_PAGE(state, data) {
    state.autoOnePage = data;
  },
  SET_CVS_DATA(state, data) {
    state.cvsData = data;
  },
  setCvSectionTitle(state, data) {
    state.section_titles = data
  }
}

export default mutations
